// extracted by mini-css-extract-plugin
export default {"container":"orderStatus_container__bD9c0","packageOrder":"orderStatus_packageOrder__zhSII","order":"orderStatus_order__GSCZ3"};